
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "downloads"
    }}>{`Downloads`}</h1>
    <p>{`Apache Atlas release artifacts are distributed via mirror sites and should be checked for tampering using GPG or SHA-256.`}</p>
    <p>{`The table below lists release artifacts and their associated signatures and hashes. The keys used to sign the release
artifacts can be found in our published `}<a parentName="p" {...{
        "href": "https://downloads.apache.org/atlas/KEYS"
      }}>{`KEYS file`}</a>{`.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}><strong parentName="th">{`Version`}</strong></th>
          <th parentName="tr" {...{
            "align": "center"
          }}><strong parentName="th">{`Release Date`}</strong></th>
          <th parentName="tr" {...{
            "align": "center"
          }}><strong parentName="th">{`Tarball`}</strong></th>
          <th parentName="tr" {...{
            "align": "center"
          }}><strong parentName="th">{`GPG`}</strong></th>
          <th parentName="tr" {...{
            "align": "center"
          }}><strong parentName="th">{`Hash`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.2.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2021-08-17`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://www.apache.org/dyn/closer.cgi/atlas/2.2.0/apache-atlas-2.2.0-sources.tar.gz"
            }}>{`source`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://www.apache.org/dist/atlas/2.2.0/apache-atlas-2.2.0-sources.tar.gz.asc"
            }}>{`signature`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://www.apache.org/dist/atlas/2.2.0/apache-atlas-2.2.0-sources.tar.gz.sha512"
            }}>{`SHA512`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.1.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2020-07-15`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://www.apache.org/dyn/closer.cgi/atlas/2.1.0/apache-atlas-2.1.0-sources.tar.gz"
            }}>{`source`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://www.apache.org/dist/atlas/2.1.0/apache-atlas-2.1.0-sources.tar.gz.asc"
            }}>{`signature`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://www.apache.org/dist/atlas/2.1.0/apache-atlas-2.1.0-sources.tar.gz.sha512"
            }}>{`SHA512`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`0.8.4`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2019-06-21`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://www.apache.org/dyn/closer.cgi/atlas/0.8.4/apache-atlas-0.8.4-sources.tar.gz"
            }}>{`source`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://www.apache.org/dist/atlas/0.8.4/apache-atlas-0.8.4-sources.tar.gz.asc"
            }}>{`signature`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://www.apache.org/dist/atlas/0.8.4/apache-atlas-0.8.4-sources.tar.gz.sha512"
            }}>{`SHA512`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`1.2.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2019-06-07`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://www.apache.org/dyn/closer.cgi/atlas/1.2.0/apache-atlas-1.2.0-sources.tar.gz"
            }}>{`source`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://www.apache.org/dist/atlas/1.2.0/apache-atlas-1.2.0-sources.tar.gz.asc"
            }}>{`signature`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://www.apache.org/dist/atlas/1.2.0/apache-atlas-1.2.0-sources.tar.gz.sha512"
            }}>{`SHA512`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2.0.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2019-05-13`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/atlas/2.0.0/apache-atlas-2.0.0-sources.tar.gz"
            }}>{`source`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/atlas/2.0.0/apache-atlas-2.0.0-sources.tar.gz.asc"
            }}>{`signature`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/atlas/2.0.0/apache-atlas-2.0.0-sources.tar.gz.sha512"
            }}>{`SHA512`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`0.8.3`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2018-10-31`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/atlas/0.8.3/apache-atlas-0.8.3-sources.tar.gz"
            }}>{`source`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/atlas/0.8.3/apache-atlas-0.8.3-sources.tar.gz.asc"
            }}>{`signature`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/atlas/0.8.3/apache-atlas-0.8.3-sources.tar.gz.sha512"
            }}>{`SHA512`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`1.1.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2018-09-14`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/atlas/1.1.0/apache-atlas-1.1.0-sources.tar.gz"
            }}>{`source`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/atlas/1.1.0/apache-atlas-1.1.0-sources.tar.gz.asc"
            }}>{`signature`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/atlas/1.1.0/apache-atlas-1.1.0-sources.tar.gz.sha512"
            }}>{`SHA512`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`1.0.0`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2018-06-02`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/atlas/1.0.0/apache-atlas-1.0.0-sources.tar.gz"
            }}>{`source`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/atlas/1.0.0/apache-atlas-1.0.0-sources.tar.gz.asc"
            }}>{`signature`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/atlas/1.0.0/apache-atlas-1.0.0-sources.tar.gz.sha512"
            }}>{`SHA512`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`0.8.2`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2018-02-05`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/atlas/0.8.2/apache-atlas-0.8.2-sources.tar.gz"
            }}>{`source`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/atlas/0.8.2/apache-atlas-0.8.2-sources.tar.gz.asc"
            }}>{`signature`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/atlas/0.8.2/apache-atlas-0.8.2-sources.tar.gz.sha512"
            }}>{`SHA512`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`0.8.1`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2017-08-29`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/atlas/0.8.1/apache-atlas-0.8.1-sources.tar.gz"
            }}>{`source`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/atlas/0.8.1/apache-atlas-0.8.1-sources.tar.gz.asc"
            }}>{`signature`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/atlas/0.8.1/apache-atlas-0.8.1-sources.tar.gz.sha512"
            }}>{`SHA512`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`0.8.0-incubating`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2017-06-26`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/incubator/atlas/0.8.0-incubating/apache-atlas-0.8-incubating-sources.tar.gz"
            }}>{`source`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/incubator/atlas/0.8.0-incubating/apache-atlas-0.8-incubating-sources.tar.gz.asc"
            }}>{`signature`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/incubator/atlas/0.8.0-incubating/apache-atlas-0.8-incubating-sources.tar.gz.sha512"
            }}>{`SHA512`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`0.7.1-incubating`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2017-01-28`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/incubator/atlas/0.7.1-incubating/apache-atlas-0.7.1-incubating-sources.tar.gz"
            }}>{`source`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/incubator/atlas/0.7.1-incubating/apache-atlas-0.7.1-incubating-sources.tar.gz.asc"
            }}>{`signature`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/incubator/atlas/0.7.1-incubating/apache-atlas-0.7.1-incubating-sources.tar.gz.mds"
            }}>{`checksum`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`0.7.0-incubating`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2016-07-09`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/incubator/atlas/0.7.0-incubating/apache-atlas-0.7-incubating-sources.tar.gz"
            }}>{`source`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/incubator/atlas/0.7.0-incubating/apache-atlas-0.7-incubating-sources.tar.gz.asc"
            }}>{`signature`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/incubator/atlas/0.7.0-incubating/apache-atlas-0.7-incubating-sources.tar.gz.sha512"
            }}>{`SHA512`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`0.6.0-incubating`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2015-12-31`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/incubator/atlas/0.6.0-incubating/apache-atlas-0.6-incubating-sources.tar.gz"
            }}>{`source`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/incubator/atlas/0.6.0-incubating/apache-atlas-0.6-incubating-sources.tar.gz.asc"
            }}>{`signature`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/incubator/atlas/0.6.0-incubating/apache-atlas-0.6-incubating-sources.tar.gz.sha"
            }}>{`SHA`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`0.5.0-incubating`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2015-07-10`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/incubator/atlas/0.5.0-incubating/apache-atlas-0.5-incubating-sources.tar.gz"
            }}>{`source`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/incubator/atlas/0.5.0-incubating/apache-atlas-0.5-incubating-sources.tar.gz.asc"
            }}>{`signature`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://archive.apache.org/dist/incubator/atlas/0.5.0-incubating/apache-atlas-0.5-incubating-sources.tar.gz.sha"
            }}>{`SHA`}</a></td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "verify-the-integrity-of-the-files"
    }}>{`Verify the integrity of the files`}</h2>
    <p>{`It is essential that you verify the integrity of the downloaded file using the PGP signature (.asc file) or a hash
(.md5 or .sha* file). Please read `}<a parentName="p" {...{
        "href": "https://www.apache.org/info/verification.html"
      }}>{`Verifying Apache Software Foundation Releases`}</a>{`
for more information on why you should verify our releases.`}</p>
    <p>{`The PGP signature can be verified using PGP or GPG, with the following steps:`}</p>
    <ul>
      <li parentName="ul">{`Download the release artifact from the link in the table above`}</li>
      <li parentName="ul">{`Download the signature file for the release from the link in the table above`}</li>
      <li parentName="ul">{`Download `}<a parentName="li" {...{
          "href": "https://downloads.apache.org/atlas/KEYS"
        }}>{`Apache Atlas KEYS file`}</a></li>
      <li parentName="ul">{`Verify the signatures using one of the following:`}</li>
    </ul>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`gpg --import KEYS
gpg --verify downloaded_file.asc downloaded_file`}
    </SyntaxHighlighter>
    <p>{`or`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`pgpk -a KEYS
pgpv downloaded_file.asc`}
    </SyntaxHighlighter>
    <p>{`or`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`pgp -ka KEYS
pgp downloaded_file.asc`}
    </SyntaxHighlighter>
    <h2 {...{
      "id": "release-notes"
    }}>{`Release Notes`}</h2>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "../2.2.0/index"
        }}>{`Atlas 2.2.0`}</a>{` (Released on 2021/08/17)`}</strong></p>
    <ul>
      <li parentName="ul">{`(new) Deferred Action: classification propagation will be handled as a background task (AtlasTask)`}</li>
      <li parentName="ul">{`Re-indexing: added Re-indexing as part of JAVA_PATCH`}</li>
      <li parentName="ul">{`Model Change: created JAVA_PATCH to add new super types to existing entities`}</li>
      <li parentName="ul">{`Export Service: added support for Business Metadata in Atlas Export API`}</li>
      <li parentName="ul">{`Admin/AtlasTask API: added HA support for admin/task API`}</li>
      <li parentName="ul">{`Entity definition: provided option to add mandatory attribute to existing entity definition`}</li>
      <li parentName="ul">{`DSL Search:`}
        <ul parentName="li">
          <li parentName="ul">{`added support for glossary terms and relationship`}</li>
          <li parentName="ul">{`added support for null attribute values,`}</li>
          <li parentName="ul">{`now uses Tinkerpop GraphTraversal instead of GremlinScriptEngine for performance improvement`}</li>
          <li parentName="ul">{`added support search by classification and its attribute`}</li>
          <li parentName="ul">{`added caching mechanism for translated DSL queries`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Atlas Python Client: refactored and enhanced Atlas Python Client supporting Python 2.7`}</li>
      <li parentName="ul">{`Search: updated free-text search processor to support Elasticsearch, Support search text with special characters, optimized pagination`}</li>
      <li parentName="ul">{`Bulk Glossary Import: improved and enhanced Bulk Glossary Import supporting import with relations`}</li>
      <li parentName="ul">{`Performance: improved performance of GraphHelper's guid and status getter methods`}</li>
      <li parentName="ul">{`Authorization: enhanced Atlas authorization for Add/Update/Remove classification on entities, "admin-audits" for Atlas Admin Audits authorization`}</li>
      <li parentName="ul">{`Notification: improved NotificationHookConsumer for Large Message Processing`}</li>
      <li parentName="ul">{`Export/Import Service: enhanced Export/Import Service to conditionally Support Simultaneous Operations and to export Terms`}</li>
      <li parentName="ul">{`Hive Hook: added support HiveServer2 Hook to send Lineage-only Messages`}</li>
      <li parentName="ul">{`Apache Flink: introduced model to capture Apache Flink entities and relationships`}</li>
      <li parentName="ul">{`GCP: introduced model to capture GCP entities and relationships`}</li>
      <li parentName="ul">{`ADLS-Gen2: updated model for Azure Data Lake Storage Gen2 entities and relationships`}</li>
      <li parentName="ul">{`Dependencies Upgrade: JanusGraph, elasticsearch, JQuery, Http core, Http Client, slf4j, log4j, ant, gremlin, Solr, groovy, netty, Kafka`}</li>
      <li parentName="ul">{`UI: fixed Atlas Web UI to load faster in case of large number of classifications & entities`}</li>
      <li parentName="ul">{`Docker image: improvements to Docker support`}</li>
      <li parentName="ul">{`Various bug fixes and improvements`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://issues.apache.org/jira/issues/?jql=project%20%3D%20ATLAS%20AND%20status%20%3D%20Resolved%20AND%20fixVersion%20%3D%202.2.0%20ORDER%20BY%20key%20DESC"
        }}>{`List of JIRAs resolved in Apache Atlas 2.2.0 release`}</a></li>
    </ul>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "../2.1.0/index"
        }}>{`Atlas 2.1.0`}</a>{` (Released on 2020/07/15)`}</strong></p>
    <ul>
      <li parentName="ul">{`Quick Search: provides a simpler search experience with type-ahead suggestions`}</li>
      <li parentName="ul">{`Business Metadata: enables augmenting entity-types with additional attributes, search entities using these attributes`}</li>
      <li parentName="ul">{`Labels: ability to add/remove labels on entities, and search entities using labels`}</li>
      <li parentName="ul">{`Custom Attributes: ability to add entity instance specific custom attributes i.e. attributes not defined in entity-def or business metadata`}</li>
      <li parentName="ul">{`Entity Purge: added REST APIs to purge deleted entities`}</li>
      <li parentName="ul">{`Search: ability to find entities by more than one classification`}</li>
      <li parentName="ul">{`Performance: improvements in lineage retrieval and classification-propagation`}</li>
      <li parentName="ul">{`Notification: ability to process notificaitons from multiple Kafka topics`}</li>
      <li parentName="ul">{`Hive Hook: tracks process-executions via hive_process_execution entities`}</li>
      <li parentName="ul">{`Hive Hook: catures DDL operations via hive_db_ddl and hive_table_ddl entities`}</li>
      <li parentName="ul">{`Notification: introduced shell entities to record references to non-existing entities in notifications`}</li>
      <li parentName="ul">{`Spark: added model to capture Spark entities, processes and relationships`}</li>
      <li parentName="ul">{`AWS S3: introduced updated model to capture AWS S3 entities and relationships`}</li>
      <li parentName="ul">{`ADLS-Gen2: introduced model to capture Azure Data Lake Storage Gen2 entities and relationships`}</li>
      <li parentName="ul">{`Dependencies: JanusGraph 0.5.1, Tinkerpop 3.4.6, Spring Framework 4.3.20`}</li>
      <li parentName="ul">{`Authorization: updated to cover new features, like: business metadata, labels, purge`}</li>
      <li parentName="ul">{`UI: multiple UI improvements, including a beta UI`}</li>
      <li parentName="ul">{`Various Bug-fixes and optimizations`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://issues.apache.org/jira/issues/?jql=project%20%3D%20ATLAS%20AND%20status%20%3D%20Resolved%20AND%20fixVersion%20%3D%202.1.0%20ORDER%20BY%20key%20DESC"
        }}>{`List of JIRAs resolved in Apache Atlas 2.1.0 release`}</a></li>
    </ul>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "../2.0.0/index"
        }}>{`Atlas 2.0.0`}</a>{` (Released on 2019/05/14)`}</strong></p>
    <ul>
      <li parentName="ul">{`Soft-reference attribute implementation.`}</li>
      <li parentName="ul">{`Unique-attributes constraints at graph store-level`}</li>
      <li parentName="ul">{`Atlas Index Repair tool for Janusgraph`}</li>
      <li parentName="ul">{`Relationship notifications when new relationships are created in atlas`}</li>
      <li parentName="ul">{`Atlas Import Transform handler implementation`}</li>
      <li parentName="ul">{`Updated component versions to use Hadoop 3.1, Hive 3.1, HBase 2.0, Solr 7.5 and Kafka 2.0`}</li>
      <li parentName="ul">{`Updated JanusGraph version to 0.3.1`}</li>
      <li parentName="ul">{`Updated authentication to support trusted proxy`}</li>
      <li parentName="ul">{`Updated patch framework to persist typedef patches applied to atlas and handle data patches.`}</li>
      <li parentName="ul">{`Updated metrics module to collect notification metrics`}</li>
      <li parentName="ul">{`Updated Atlas Export to support incremental export of metadata.`}</li>
      <li parentName="ul">{`Notification Processing Improvements:`}
        <ul parentName="li">
          <li parentName="ul">{`Notification processing to support batch-commits`}</li>
          <li parentName="ul">{`New option in notification processing to ignore potentially incorrect hive_column_lineage`}</li>
          <li parentName="ul">{`Updated Hive hook to avoid duplicate column-lineage entities; also updated Atlas server to skip duplicate column-lineage entities`}</li>
          <li parentName="ul">{`Improved batch processing in notificaiton handler to avoid processing of an entity multiple times`}</li>
          <li parentName="ul">{`Add option to ignore/prune metadata for temporary/staging hive tables`}</li>
          <li parentName="ul">{`Avoid unnecessary lookup when creating new relationships`}</li>
        </ul>
      </li>
      <li parentName="ul">{`UI Improvements:`}
        <ul parentName="li">
          <li parentName="ul">{`UI: Display counts besides the Type and Classification dropdown list in basic search`}</li>
          <li parentName="ul">{`UI: Display lineage information for process entities`}</li>
          <li parentName="ul">{`UI: Display entity specific icon for the lineage graph`}</li>
          <li parentName="ul">{`UI: Add relationships table inside relationships view in entity details page.`}</li>
          <li parentName="ul">{`UI: Add service-type dropdown in basic search to filter entitydef type.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Various Bug-fixes and optimizations`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://issues.apache.org/jira/issues/?jql=project%20%3D%20ATLAS%20AND%20status%20%3D%20Resolved%20AND%20fixVersion%20%3D%202.0.0%20ORDER%20BY%20updated%20DESC%2C%20priority%20DESC"
        }}>{`List of JIRAs resolved in Apache Atlas 2.0.0 release`}</a></li>
    </ul>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "../1.1.0/index"
        }}>{`Atlas 1.1.0`}</a>{` (Released on 2018/09/17)`}</strong></p>
    <ul>
      <li parentName="ul">{`Updated authorization model to support access control on relationship operations`}</li>
      <li parentName="ul">{`Added support for AWS S3 datatypes, in Atlas server and Hive hook`}</li>
      <li parentName="ul">{`Updated `}<a parentName="li" {...{
          "href": "https://janusgraph.org/"
        }}>{`JanusGraph`}</a>{` version from 0.2.0 to 0.3.0`}</li>
      <li parentName="ul">{`Updated hooks to send Kafka notifications asynchronously`}</li>
      <li parentName="ul">{`Enhanced classification-propagation with options to handle entity-deletes`}</li>
      <li parentName="ul">{`BugFixes and Optimizations`}</li>
    </ul>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "../1.0.0/index"
        }}>{`Atlas 1.0.0`}</a>{` (Released on 2018/06/02)`}</strong></p>
    <ul>
      <li parentName="ul">{`Core model enhancement to support Relationship as first-class construct`}</li>
      <li parentName="ul">{`Support for JanusGraph graph database`}</li>
      <li parentName="ul">{`New DSL implementation, using ANTLR instead of Scala`}</li>
      <li parentName="ul">{`Removal of older type system implementation in atlas-typesystem library`}</li>
      <li parentName="ul">{`Metadata security - fine grained authorization`}</li>
      <li parentName="ul">{`Notification enhancements to support V2 style data structures`}</li>
      <li parentName="ul">{`Jackson library update from 1.9.13 to 2.9.2`}</li>
      <li parentName="ul">{`Classification propagation via entity relationships`}</li>
      <li parentName="ul">{`Glossary terms, categories`}</li>
      <li parentName="ul">{`HBase Hook`}</li>
      <li parentName="ul">{`UI updates to show entity relationships`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://issues.apache.org/jira/issues/?jql=project%20%3D%20Atlas%20AND%20resolution%20%3D%20Fixed%20AND%20fixVersion%20%3D%201.0.0%20ORDER%20BY%20key%20DESC"
        }}>{`List of JIRAs resolved in Apache Atlas 1.0.0 release`}</a></li>
    </ul>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "../0.8.2/index"
        }}>{`Atlas 0.8.2`}</a>{` (Released on 2018/02/05)`}</strong></p>
    <ul>
      <li parentName="ul">{`Search improvements:`}
        <ul parentName="li">
          <li parentName="ul">{`Basic search enhancement to optionally exclude sub-type entities and sub-classification-types`}</li>
          <li parentName="ul">{`Basic search to return classification attributes`}</li>
          <li parentName="ul">{`Support for saving searches`}</li>
          <li parentName="ul">{`UI support to reorder columns in search results page`}</li>
        </ul>
      </li>
      <li parentName="ul">{`UI - updates for classification rendering – tree/flat view`}</li>
      <li parentName="ul">{`UI – minification of js, css; cache busting for static content (css, js)`}</li>
      <li parentName="ul">{`notification updates to handle large messages`}</li>
      <li parentName="ul">{`fix type initialization issues in HA deployment`}</li>
      <li parentName="ul">{`In HA, the passive node redirects the request with wrong URL encoding`}</li>
      <li parentName="ul">{`tool kit to recover from lost/bad index data`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://issues.apache.org/jira/issues/?jql=project%20%3D%20Atlas%20AND%20fixVersion%20%3D%200.8.2%20ORDER%20BY%20key%20ASC"
        }}>{`List of JIRAs resolved in Apache Atlas 0.8.2 release`}</a></li>
    </ul>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "../0.8.1/index"
        }}>{`Atlas 0.8.1`}</a>{` (Released on 2017/08/29)`}</strong></p>
    <ul>
      <li parentName="ul">{`Basic-search improvement in use of index for attribute filtering`}</li>
      <li parentName="ul">{`DSL query enhancement to support 'like' operator`}</li>
      <li parentName="ul">{`REST API and UI enhancements to update classification attributes`}</li>
      <li parentName="ul">{`Export/import support to copy data between Apache Atlas instances`}</li>
      <li parentName="ul">{`Ability to delete a tag from UI (and API)`}</li>
      <li parentName="ul">{`UI enhancements: lineage, attribute search filter, ability to search historical data`}</li>
      <li parentName="ul">{`Knox SSO for Atlas REST APIs`}</li>
      <li parentName="ul">{`Moved from use of Guice + Spring framework for dependency-injection to use only Spring framework`}</li>
    </ul>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "../0.8.0-incubating/index"
        }}>{`Atlas 0.8-incubating`}</a>{` (Released on 2017/03/16)`}</strong></p>
    <ul>
      <li parentName="ul">{`API revamp - new, structured REST API`}</li>
      <li parentName="ul">{`Simplified search UI`}</li>
      <li parentName="ul">{`UI to create/update entities - HDFS/HBase/Kafka`}</li>
      <li parentName="ul">{`Performance and scalability improvements`}</li>
      <li parentName="ul">{`Knox SSO for Atlas UI`}</li>
    </ul>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "../0.7.1-incubating/index"
        }}>{`Atlas 0.7.1-incubating`}</a>{` (Released on 2017/01/29)`}</strong></p>
    <ul>
      <li parentName="ul">{`Performance and scalability improvements (ATLAS-1403, ATLAS-1404)`}</li>
      <li parentName="ul">{`Bug fixes`}</li>
    </ul>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "../0.7.0-incubating/index"
        }}>{`Atlas 0.7-incubating`}</a>{` (Released on 2016/07/09)`}</strong></p>
    <ul>
      <li parentName="ul">{`High Availability (ATLAS-510)`}</li>
      <li parentName="ul">{`Business Catalog / Taxonomy (ATLAS-491)`}</li>
      <li parentName="ul">{`Improved Hive Integration (ATLAS-492)`}</li>
      <li parentName="ul">{`Improved Sqoop Integration`}</li>
      <li parentName="ul">{`Improved Falcon Integration`}</li>
      <li parentName="ul">{`Improved Storm Integration`}</li>
      <li parentName="ul">{`Improved Ambari Deployment & Management Support`}</li>
      <li parentName="ul">{`Entity Versioning / Audit (ATLAS-493)`}</li>
      <li parentName="ul">{`Performance Improvements`}</li>
      <li parentName="ul">{`Authorization (ATLAS-497)`}</li>
      <li parentName="ul">{`Atlas / Ranger Authorization Integration (ATLAS-495)`}</li>
      <li parentName="ul">{`Standalone HBase Support (ATLAS-498)`}</li>
      <li parentName="ul">{`Upgrade Support (ATLAS-631)`}</li>
    </ul>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "../0.6.0-incubating/index"
        }}>{`Atlas 0.6-incubating`}</a>{` (Released on 2015/12/30)`}</strong></p>
    <ul>
      <li parentName="ul">{`Improved Hive Server 2 Integration`}</li>
      <li parentName="ul">{`Sqoop Integration`}</li>
      <li parentName="ul">{`Falcon Integration`}</li>
      <li parentName="ul">{`Storm Integration`}</li>
      <li parentName="ul">{`Various Bug Fixes`}</li>
      <li parentName="ul">{`Atlas / Ranger Integration`}</li>
    </ul>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "../0.5.0-incubating/index"
        }}>{`Atlas 0.5-incubating`}</a>{` (Released on 2015/07/09)`}</strong></p>
    <ul>
      <li parentName="ul">{`Hive Server 2 Integration`}</li>
      <li parentName="ul">{`Basic Hive Lineage`}</li>
      <li parentName="ul">{`Basic Ambari Integration`}</li>
      <li parentName="ul">{`Kerberos Support`}</li>
      <li parentName="ul">{`DSL for query of datastore`}</li>
      <li parentName="ul">{`Basic Storage of Metadata`}</li>
      <li parentName="ul">{`Support for BerkleyDB`}</li>
      <li parentName="ul">{`Support for Titan 0.5`}</li>
      <li parentName="ul">{`Support`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;